<div oui-dialog-title>
  Renommer la fiche conseil
  <oui-button type="icon" oui-dialog-close>
    <oui-icon>close</oui-icon>
  </oui-button>
</div>

<oui-dialog-content>
  <div class="flex-vertical flex-start gap-24 oui-form-field-lg" *ngIf="!isloading">
    <div style="white-space: pre-line" class="body-1 color-on-surface-emphasis">
      Vous pouvez modifier ici le nom de la fiche conseil. Cela modifiera également le nom du fichier PDF généré.
    </div>
    <oui-textfield
      label="Nom de la fiche conseil"
      class="oui-form-field-lg width-100pc"
      [control]="labelControl"></oui-textfield>
  </div>
  <div class="flex-horizontal flex-center justify-center">
    <oui-loading *ngIf="isloading"></oui-loading>
  </div>
</oui-dialog-content>

<oui-dialog-actions class="gap-8">
  <oui-button type="text" class="flex-none" oui-dialog-close> Annuler </oui-button>
  <oui-button type="contained" class="flex-none" (click)="onValid()" [disabled]="!labelControl.valid && !isSaving">
    Valider
  </oui-button>
</oui-dialog-actions>
